import { applyMiddleware } from 'redux';
import { authMiddleware } from 'redux-implicit-oauth2';
import thunk from 'redux-thunk';

export default function applyDevMiddleware() {
        return applyMiddleware(thunk, authMiddleware);
}